<ng-content select="itl-search-filter-bar"></ng-content>
<div class="list-wrapper" [ngClass]="{ 'list-wrapper--noSerachbar': noSearchbar }">
  <ng-content></ng-content>
</div>
